import { TeCell, TeContainerSlim, TeIcon, TeText } from '@topcon/tuicl-react';

interface Props {
  sortKey?: string;
  sortDirection?: string;
  name: string;
  cellKey?: string;
  onHeaderClick?: (name: string) => void;
}

function HeaderCell({ sortKey, sortDirection, name, cellKey, onHeaderClick }: Props) {
  return (
    <TeCell teclick={() => onHeaderClick?.(cellKey ?? '')}>
      <TeContainerSlim gap="xs" alignItems="center">
        <TeText weight={700}>{name}</TeText>
        {cellKey && sortKey === cellKey && (
          <TeIcon
            color="icon.secondary"
            name={sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward'}
          />
        )}
      </TeContainerSlim>
    </TeCell>
  );
}

export default HeaderCell;
